import Ladda from 'ladda';

import 'readmore-js';
import '@/scripts/legacy-ui-library/vendors/bootstrap/modal';
import analytic from '@/scripts/libs/analytic';

import loginController from '@/scripts/libs/login/controller';
import { makeAuthTrackerPayload } from '@/scripts/libs/login/viddseeLoginController/strategies/helpers';
import { loginApi } from '@/scripts/webcall/v3/login';
/**
 * @typedef { import('./viddsee.types').AuthModalOpenOptions } AuthModalOpenOptions
 */
const viddsee = global._VS || {};
viddsee.ui = viddsee.ui || {};
viddsee.ui.modal = viddsee.ui.modal || {};
viddsee.Component = viddsee.Component || {};

viddsee.ui.modal.register = (($) => {
  const resetModal = function resetModal() {
    const $this = $('#modal--login');

    $this.find('#tab-modal-signin-selector').removeClass('hidden');
    $this.find('#tab-modal-signin-email-success').addClass('hidden');
    $this.find('.js-tab-modal-signin-email__error').text('');
    $this.find('.js-tab-modal-signin-email__input-email').val('');
    $this.find('.js-tab-modal-signin-email__btn-signin').prop('disabled', false);
    $this.find('.js-tab-modal-signin-email-success__email').text('');
  };

  /**
    * @param {AuthModalOpenOptions=} options
   */
  const open = function open(options = {}) {
    const $this = $('#modal--login');
    if (options.origin) {
      $this.data('signin-origin', options.origin);
    } else {
      $this.removeData('origin');
    }
    if (options.callback) {
      $this.data('signin-callback', options.callback);
    } else {
      $this.removeData('callback');
    }

    const loginReasonEl = document.getElementById('modal--login-login-reason');
    loginReasonEl.innerHTML = '';
    if (options.loginReason) {
      const loginReasonParagraphEl = document.createElement('p');
      loginReasonParagraphEl.innerText = options.loginReason;
      loginReasonEl.appendChild(loginReasonParagraphEl);
    }

    // Add option to prevent modal from getting closed
    if (options.isPersistent) {
      $this.modal({
        backdrop: 'static',
        keyboard: false,
      });
      $this.addClass('is-persistent');
    } else {
      $this.removeClass('is-persistent');
      $this.modal('show');
    }

    $this.data('authTrackerPayload', options.authTrackerPayload ?? null);
  };

  const init = function init(el) {
    const $el = $(el);
    if ($el.length <= 0) { return; }
    $el.modal({
      show: false,
    });

    const $this = $el;

    $this.on('show.bs.modal', (e) => {
      resetModal();
    });

    // Init modal functionalities
    $this.find('.btn--fb-login').on('click', (e) => {
      e.preventDefault();

      const $this = $('#modal--login');
      const signinCallback = $this.data('signin-callback');

      loginController.methods.facebook({
        callback: signinCallback,
        authTracker: $this.data('authTrackerPayload'),
      });
    });

    function handleCredentialResponse(response) {
      analytic.send({
        category: 'sign-in',
        action: 'google',
      });
      const authTrackerParams = makeAuthTrackerPayload($this.data('authTrackerPayload')?.authTracker);
      const currentUrl = new URL(window.location.href);
      loginApi.google(undefined, undefined,
        {
          idToken: response.credential,
          intent: authTrackerParams.intent || '',
          screenName: authTrackerParams.screen_name || '',
          section: authTrackerParams.section || '',
          resourceUri: authTrackerParams.resource_uri || '',
          query: authTrackerParams.query || '',
        }).then((response) => {
        if (response.data.context === 'login') {
          currentUrl.searchParams.append('access_token', response.data.accessToken);
          window.location.href = currentUrl.href;
        } else if (response.data.context === 'registration') {
          window.location.href = `/registration_google?access_token=${response.data.accessToken}&origin=${currentUrl}`;
        }
        $this.find('.modal--login__dialog').addClass('hidden');
      });
    }
    window.onload = () => {
      window.google.accounts.id.initialize({
        client_id: '306209973734-7n9367usv4vin5911p8ahhdass0mpaia.apps.googleusercontent.com',
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById('google-signin-btn'),
        { theme: 'outline', size: 'large', width: '230px' },
      );
    };

    $this.find('.js-tab-modal-signin-selector__btn-action--email').on('click', (e) => {
      e.preventDefault();

      $this.find('#tab-modal-signin-selector').removeClass('active');
      $this.find('#tab-modal-signin-email').addClass('active');
    });

    // TODO: Do a proper validation error feedback
    $this.find('.js-tab-modal-signin-email__form').on('submit', (e) => {
      e.preventDefault();
      const emailAddress = $this.find('.js-tab-modal-signin-email__input-email').val();
      if (typeof emailAddress !== 'string') return;

      $('.js-tab-modal-signin-email__btn-signin').prop('disabled', true);

      const l = Ladda.create($this.find('.js-tab-modal-signin-email__btn-signin')[0]);
      l.start();
      loginController.methods.email({
        email: emailAddress,
        origin: $this.data('signin-origin') || location.href,
        callback: $this.data('signin-callback') || '',
        authTracker: $this.data('authTrackerPayload'),
      })
        .then((data) => {
          $this.find('#tab-modal-signin-selector').addClass('hidden');
          $this.find('#tab-modal-signin-email-success').removeClass('hidden');
          $this.find('.modal--email-confirm__dialog__email').text(emailAddress);
        })
        .catch((error) => {
          const errorMsg = (typeof error === 'string') ? error : I18n.t('javascript.try-again');
          $this.find('.js-tab-modal-signin-email__error').text(errorMsg);
        })
        .then(() => {
          l.stop();
          $('.js-tab-modal-signin-email__btn-signin').prop('disabled', false);
        });
    });

    $this.find('.js-tab-modal-signin-email__link-cancel').on('click', (e) => {
      e.preventDefault();
      resetModal();
    });
  };

  return {
    init,
    open,
  };
})($);

$(() => {
  // Navigation related initialisation

  // Sign up button
  viddsee.ui.modal.register.init('#modal--login');

  $('.form-locale-selector-dropdown').on('change', (e) => {
    const selectBox = e.currentTarget;

    const $form = $(selectBox.form);
    ga(() => {
      const trackers = ga.getAll();
      const tracker = trackers.length > 0 ? trackers[0] : null;
      const currentLocale = tracker ? tracker.get('dimension2') : 'undefined';
      const newLocale = selectBox.options[selectBox.selectedIndex].value;
      const gaEvent = $form.hasClass('form-locale-selector--mobile')
        ? 'language-change-mobile'
        : 'language-change-desktop';
      const gaLabel = currentLocale + ' -> ' + newLocale;

      ga('send', 'event', 'localization', gaEvent, gaLabel);
    });

    selectBox.form.submit();
  });
});

export default viddsee;
